import React, { useMemo, useState } from 'react'

import { Column } from '../../../../components/layouts/columns'
import { Button } from '../../../../components/ui/button'
import { Checkbox } from '../../../../components/ui/checkbox'
import { Icon } from '../../../../components/icons'
import { Table } from '../../../../components/ui/table'
import { Input } from '../../../../components/ui/input'
import { UpdateValueInArrayOfObject } from '../../../../utils/handlingArrays'
import { Select } from '../../../../components/ui/select'
import { PathDoc } from '../../../../router/docs'

export const ClientsFormEventsFinally = ({ loading, formContext, setFormContext, setSelectCandidacy, actions }) => {
  const [search, setSearch] = useState('')

  const listFiltered = useMemo(() => {
    const data = formContext?.list_reviews || []
    const searchText = (search || '').toLowerCase()

    return data.filter((item) => {
      if (searchText) {
        const match =
          (item.name && item.name.toLowerCase().includes(searchText)) ||
          (item.cpf && String(item.cpf).toLowerCase().includes(searchText)) ||
          (item.positionName && item.positionName.toLowerCase().includes(searchText))
        if (!match) return false
      }

      return true
    })
  }, [formContext?.list_reviews, search])

  return formContext?.statusEvent === 'open' ? (
    <>
      <div className="box mt-5">
        <Column.Root className="mx-5 my-2">
          <Checkbox.Root text="Registrar Aportes/Descontos no pagamentos dos colaboradores">
            <Checkbox.Content
              key={`checkhasFavorites`}
              value={formContext}
              setValue={setFormContext}
              field={'hasDebts'}
            />
          </Checkbox.Root>
        </Column.Root>
        {formContext?.hasDebts ? (
          <>
            <div style={{ height: 1 }} className="is-fullwidth has-background-grey-lighter my-5"></div>
            <Column.Root>
              <Column.Content>
                <Column.Root>
                  <Column.Content style={{ display: 'flex', gap: '1rem' }}>
                    <p className="subtitle is-size-5 has-text-grey">
                      <Icon size={20} className={'mr-3'}>
                        bill
                      </Icon>
                      Lista de Aportes/Descontos
                    </p>
                    <Button.Content>
                      <Button.A
                        className={'mr-4'}
                        link={PathDoc.EventAddCollab}
                        openNew
                        color="is-light"
                        loading={loading}
                      >
                        Tutorial
                      </Button.A>
                    </Button.Content>
                  </Column.Content>
                  <Column.Content>
                    <Button.Root align="right">
                      <Button.Content>
                        <Button.Bt
                          color="is-success"
                          colorText="has-text-white"
                          loading={loading}
                          action={() => {
                            setSelectCandidacy(true)
                            setFormContext((prev) => ({ ...prev, typeSelectCandidacy: 'debts' }))
                          }}
                        >
                          +
                        </Button.Bt>
                      </Button.Content>
                    </Button.Root>
                  </Column.Content>
                </Column.Root>

                {formContext?.list_debts && (
                  <Table.Root className="is-fullwidth is-hoverable is-narrow has-text-centered">
                    <Table.Head>
                      <Table.Row key={'tableEventsHead'}>
                        <Table.Cell className="is-size-7">Data</Table.Cell>
                        <Table.Cell className="is-size-7">Vaga</Table.Cell>
                        <Table.Cell className="is-size-7">Colaborador</Table.Cell>
                        <Table.Cell className="is-size-7">CPF</Table.Cell>
                        <Table.Cell className="is-size-7">Aporte/Desconto</Table.Cell>
                        <Table.Cell className="is-size-7">Valor</Table.Cell>
                        <Table.Cell className="is-size-7">Motivo</Table.Cell>
                        <Table.Cell className="is-size-7">Ações</Table.Cell>
                      </Table.Row>
                    </Table.Head>
                    <Table.Body>
                      {(formContext?.list_debts || []).map((candidacy) => {
                        const indexDebt = candidacy.index
                        return (
                          <Table.Row key={`row_${indexDebt}`}>
                            <Table.Cell className="is-size-7 is-vcentered is-centered">{candidacy.date}</Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered is-centered">
                              {candidacy.positionName}
                            </Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered is-centered">{candidacy.name}</Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered is-centered">{candidacy.cpf}</Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered is-centered" size={10}>
                              <Select.Root>
                                <Select.Content
                                  className="is-small is-rounded"
                                  required={true}
                                  color="is-grey"
                                  value={candidacy?.typeDebt}
                                  setValue={(value) => {
                                    setFormContext((prev) => {
                                      const newList = UpdateValueInArrayOfObject(
                                        prev.list_debts,
                                        'index',
                                        indexDebt,
                                        'typeDebt',
                                        value,
                                      )
                                      return {
                                        ...prev,
                                        list_debts: [...newList],
                                      }
                                    })
                                  }}
                                >
                                  <Select.Option value="D" title="Desconto" />
                                  <Select.Option value="C" title="Aporte" />
                                </Select.Content>
                              </Select.Root>
                            </Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered is-centered" size={150}>
                              <Input.Root>
                                <Input.Contents alignIcon={'left'}>
                                  <Input.Icon align="is-left" className="is-size-7">
                                    R$
                                  </Input.Icon>
                                  <Input.Prompt
                                    className="is-small is-rounded"
                                    required={true}
                                    type="number"
                                    color="is-grey"
                                    value={candidacy?.valueDebt}
                                    setValue={(value) => {
                                      setFormContext((prev) => {
                                        const newList = UpdateValueInArrayOfObject(
                                          prev.list_debts,
                                          'index',
                                          indexDebt,
                                          'valueDebt',
                                          value,
                                        )
                                        return {
                                          ...prev,
                                          list_debts: [...newList],
                                        }
                                      })
                                    }}
                                  ></Input.Prompt>
                                </Input.Contents>
                              </Input.Root>
                            </Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered is-centered">
                              <Input.Root>
                                <Input.Prompt
                                  className="is-small is-rounded"
                                  required={true}
                                  color="is-grey"
                                  value={candidacy?.motivoDebt}
                                  setValue={(value) => {
                                    setFormContext((prev) => {
                                      const newList = UpdateValueInArrayOfObject(
                                        prev.list_debts,
                                        'index',
                                        indexDebt,
                                        'motivoDebt',
                                        value,
                                      )
                                      return {
                                        ...prev,
                                        list_debts: [...newList],
                                      }
                                    })
                                  }}
                                ></Input.Prompt>
                              </Input.Root>
                            </Table.Cell>
                            <Table.Cell className="is-vcentered is-centered">
                              <Button.Root align="centered">
                                <Button.Content>
                                  <Button.Bt
                                    className="is-small"
                                    color="is-light"
                                    loading={loading}
                                    action={() => {
                                      actions.duplicated(candidacy, 'list_debts')
                                    }}
                                    title="Duplicar"
                                  >
                                    <Icon size={15}>copy</Icon>
                                  </Button.Bt>
                                </Button.Content>
                                <Button.Content>
                                  <Button.Bt
                                    className="is-small"
                                    color="is-danger"
                                    colorText="has-text-white"
                                    loading={loading}
                                    action={() => {
                                      actions.delete(indexDebt, 'list_debts')
                                    }}
                                    title="Excluir"
                                  >
                                    <Icon size={15}>trash</Icon>
                                  </Button.Bt>
                                </Button.Content>
                              </Button.Root>
                            </Table.Cell>
                          </Table.Row>
                        )
                      })}
                    </Table.Body>
                  </Table.Root>
                )}
              </Column.Content>
            </Column.Root>
          </>
        ) : (
          <></>
        )}
      </div>

      <div className="box mt-5">
        <Column.Root className="mx-5 my-2">
          <Checkbox.Root text="Quero Favoritar Colaboradores">
            <Checkbox.Content
              key={`checkhasFavorites`}
              value={formContext}
              setValue={setFormContext}
              field={'hasFavorites'}
            />
          </Checkbox.Root>
          <Button.Content>
            <Button.A className={'ml-4'} link={PathDoc.EventAddCollab} openNew color="is-light" loading={loading}>
              Tutorial
            </Button.A>
          </Button.Content>
        </Column.Root>

        {formContext?.hasFavorites ? (
          <>
            <Column.Root className="my-2 mx-6">
              <Checkbox.Root text="Adicionar essa Staff aos Favoritos">
                <Checkbox.Content
                  key={`checkfavoriteAll`}
                  value={formContext}
                  setValue={setFormContext}
                  field={'favoriteAll'}
                />
              </Checkbox.Root>
            </Column.Root>
            <Column.Root className="mx-5 my-2">
              {/* <Column.Content size="is-2" className="ml-3">
                <Checkbox.Root text="Criar nova equipe">
                  <Checkbox.Content
                    key={`checkCreateNewTeams`}
                    value={formContext}
                    setValue={setFormContext}
                    field={'createNewTeams'}
                  />
                </Checkbox.Root>
              </Column.Content> */}

              {formContext?.createNewTeams && (
                <Column.Content>
                  <Input.Root>
                    <Input.Prompt
                      required={true}
                      color="is-grey"
                      value={formContext}
                      setValue={setFormContext}
                      field={'nameTeams'}
                      placeholder="Digite o nome da nova equipe..."
                    ></Input.Prompt>
                  </Input.Root>
                </Column.Content>
              )}
            </Column.Root>

            {!formContext?.favoriteAll && (
              <>
                <div style={{ height: 1 }} className="is-fullwidth has-background-grey-lighter my-5"></div>
                <Column.Root>
                  <Column.Content>
                    <Column.Root>
                      <Column.Content>
                        <p className="subtitle is-size-5 has-text-grey">
                          <Icon size={20} className={'mr-3'}>
                            favorite
                          </Icon>
                          Lista de Favoritos
                        </p>
                      </Column.Content>
                      <Column.Content>
                        <Button.Root align="right">
                          <Button.Content>
                            <Button.Bt
                              color="is-success"
                              colorText="has-text-white"
                              loading={loading}
                              action={() => {
                                setSelectCandidacy(true)
                                setFormContext((prev) => ({ ...prev, typeSelectCandidacy: 'favorite' }))
                              }}
                            >
                              +
                            </Button.Bt>
                          </Button.Content>
                        </Button.Root>
                      </Column.Content>
                    </Column.Root>

                    {formContext?.list_favorite && (
                      <Table.Root className="is-fullwidth is-hoverable is-narrow has-text-centered">
                        <Table.Head>
                          <Table.Row key={'tableEventsHead'}>
                            <Table.Cell className="is-size-7 is-vcentered is-centered">Vaga</Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered is-centered">Colaborador</Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered is-centered">CPF</Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered is-centered">Ações</Table.Cell>
                          </Table.Row>
                        </Table.Head>
                        <Table.Body>
                          {(formContext?.list_favorite || []).map((candidacy) => {
                            const index = candidacy.index
                            return (
                              <Table.Row key={`row_favorite_${candidacy.id}${index}`}>
                                <Table.Cell className="is-size-7 is-vcentered is-centered">
                                  {candidacy.positionName}
                                </Table.Cell>
                                <Table.Cell className="is-size-7 is-vcentered is-centered">{candidacy.name}</Table.Cell>
                                <Table.Cell className="is-size-7 is-vcentered is-centered">{candidacy.cpf}</Table.Cell>
                                <Table.Cell className="is-size-7 is-vcentered is-centered">
                                  <Button.Root align="centered">
                                    <Button.Content>
                                      <Button.Bt
                                        className="is-small"
                                        color="is-danger"
                                        colorText="has-text-white"
                                        loading={loading}
                                        action={() => {
                                          actions.delete(index, 'list_favorite')
                                        }}
                                        title="Excluir"
                                      >
                                        <Icon size={15}>trash</Icon>
                                      </Button.Bt>
                                    </Button.Content>
                                  </Button.Root>
                                </Table.Cell>
                              </Table.Row>
                            )
                          })}
                        </Table.Body>
                      </Table.Root>
                    )}
                  </Column.Content>
                </Column.Root>
              </>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
      <div className="box mt-5">
        <Column.Root className="mx-5 my-2">
          <Checkbox.Root text="Quero Bloquear Candidaturas de Colaboradores">
            <Checkbox.Content
              key={`checkhasFavorites`}
              value={formContext}
              setValue={setFormContext}
              field={'hasBlocked'}
            />
          </Checkbox.Root>
          <Button.Content>
            <Button.A className={'ml-4'} link={PathDoc.EventAddCollab} openNew color="is-light" loading={loading}>
              Tutorial
            </Button.A>
          </Button.Content>
        </Column.Root>

        {formContext?.hasBlocked && (
          <>
            <div style={{ height: 1 }} className="is-fullwidth has-background-grey-lighter my-5"></div>
            <Column.Root>
              <Column.Content>
                <Column.Root>
                  <Column.Content style={{ display: 'flex', gap: '1rem' }}>
                    <p className="subtitle is-size-5 has-text-grey">
                      <Icon size={20} className={'mr-3'}>
                        block
                      </Icon>
                      Lista de Bloqueados
                    </p>
                  </Column.Content>
                  <Column.Content>
                    <Input.Root>
                      <Input.Label required={true} className="has-text-grey">
                        Motivo padrão
                      </Input.Label>
                      <Input.Prompt
                        className="is-small"
                        required={true}
                        color="is-grey"
                        value={formContext}
                        setValue={setFormContext}
                        field={'motivoDefaultBlocked'}
                        placeholder="ex.: Falta no evento..."
                      ></Input.Prompt>
                      <Input.Error>Será aplicatos a todos com motivos de bloqueios vazios...</Input.Error>
                    </Input.Root>
                  </Column.Content>
                  <Column.Content size="is-1">
                    <Button.Root align="right">
                      <Button.Content>
                        <Button.Bt
                          color="is-success"
                          colorText="has-text-white"
                          loading={loading}
                          action={() => {
                            setSelectCandidacy(true)
                            setFormContext((prev) => ({ ...prev, typeSelectCandidacy: 'blocked' }))
                          }}
                        >
                          +
                        </Button.Bt>
                      </Button.Content>
                    </Button.Root>
                  </Column.Content>
                </Column.Root>

                {formContext?.list_blocked && (
                  <Table.Root className="is-fullwidth is-hoverable is-narrow has-text-centered">
                    <Table.Head>
                      <Table.Row key={'tableEventsHead'}>
                        <Table.Cell className="is-size-7 is-vcentered is-centered">Vaga</Table.Cell>
                        <Table.Cell className="is-size-7 is-vcentered is-centered">Colaborador</Table.Cell>
                        <Table.Cell className="is-size-7 is-vcentered is-centered">CPF</Table.Cell>
                        <Table.Cell className="is-size-7 is-vcentered is-centered">Motivo</Table.Cell>
                        <Table.Cell className="is-size-7 is-vcentered is-centered">Ações</Table.Cell>
                      </Table.Row>
                    </Table.Head>
                    <Table.Body>
                      {(formContext?.list_blocked || []).map((candidacy) => {
                        const index = candidacy.index
                        return (
                          <Table.Row key={`row_blocked_${candidacy.id}${index}`}>
                            <Table.Cell className="is-size-7 is-vcentered is-centered">
                              {candidacy.positionName}
                            </Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered is-centered">{candidacy.name}</Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered is-centered">{candidacy.cpf}</Table.Cell>

                            <Table.Cell className="is-size-7 is-vcentered is-centered">
                              <Input.Root>
                                <Input.Prompt
                                  className="is-small"
                                  color="is-grey"
                                  value={candidacy?.motivoBlocked}
                                  setValue={(value) => {
                                    setFormContext((prev) => {
                                      const newList = UpdateValueInArrayOfObject(
                                        prev.list_blocked,
                                        'index',
                                        index,
                                        'motivoBlocked',
                                        value,
                                      )
                                      return {
                                        ...prev,
                                        list_blocked: [...newList],
                                      }
                                    })
                                  }}
                                ></Input.Prompt>
                              </Input.Root>
                            </Table.Cell>
                            <Table.Cell className="is-size-7 is-vcentered is-centered">
                              <Button.Root align="centered">
                                <Button.Content>
                                  <Button.Bt
                                    className="is-small"
                                    color="is-danger"
                                    colorText="has-text-white"
                                    loading={loading}
                                    action={() => {
                                      actions.delete(index, 'list_blocked')
                                    }}
                                    title="Excluir"
                                  >
                                    <Icon size={15}>trash</Icon>
                                  </Button.Bt>
                                </Button.Content>
                              </Button.Root>
                            </Table.Cell>
                          </Table.Row>
                        )
                      })}
                    </Table.Body>
                  </Table.Root>
                )}
              </Column.Content>
            </Column.Root>
          </>
        )}
      </div>

      {(formContext?.list_reviews || []).length > 0 && (
        <div className="box mt-5">
          <>
            <Column.Root className="mx-5 my-2">
              <Checkbox.Root text="Quero Avaliar o Staff do evento">
                <Checkbox.Content
                  key={`checkhasAvailable`}
                  value={formContext}
                  setValue={setFormContext}
                  field={'hasAvailable'}
                />
              </Checkbox.Root>
              <Button.Content>
                <Button.A className={'ml-4'} link={PathDoc.EventAddCollab} openNew color="is-light" loading={loading}>
                  Tutorial
                </Button.A>
              </Button.Content>
            </Column.Root>
            {formContext.hasAvailable && (
              <>
                <div style={{ height: 1 }} className="is-fullwidth has-background-grey-lighter my-5"></div>
                <Column.Root>
                  <Column.Content>
                    <Column.Root>
                      <Column.Content>
                        <p className="subtitle is-size-5 has-text-grey">
                          <Icon size={30} className={'mr-3'}>
                            review
                          </Icon>
                          Avaliar Colaboradores
                        </p>
                      </Column.Content>
                    </Column.Root>

                    <Column.Root className="">
                      <Column.Content>
                        <Input.Root>
                          <Input.Contents alignIcon={'left'}>
                            <Input.Prompt
                              value={search}
                              setValue={setSearch}
                              placeholder="Pesquisar Avaliação..."
                            ></Input.Prompt>
                            <Input.Icon align="is-left">
                              <Icon size={20}>search</Icon>
                            </Input.Icon>
                          </Input.Contents>
                        </Input.Root>
                      </Column.Content>
                    </Column.Root>

                    <Table.Root className="is-fullwidth is-hoverable is-narrow has-text-centered">
                      <Table.Head>
                        <Table.Row key={'tableEventsHead'}>
                          <Table.Cell className="is-size-7 is-vcentered is-centered">Vaga</Table.Cell>
                          <Table.Cell className="is-size-7 is-vcentered is-centered">Colaborador</Table.Cell>
                          <Table.Cell className="is-size-7 is-vcentered is-centered">CPF</Table.Cell>
                          <Table.Cell className="is-size-7 is-vcentered is-centered">Situação</Table.Cell>
                          <Table.Cell className="is-size-7 is-vcentered is-centered">Nota</Table.Cell>
                          <Table.Cell className="is-size-7 is-vcentered is-centered">Comentário</Table.Cell>
                        </Table.Row>
                      </Table.Head>
                      <Table.Body>
                        {(listFiltered || []).map((candidacy) => {
                          const id = candidacy.id
                          // console.log(formContext)
                          return (
                            <Table.Row key={`row_blocked_${candidacy.id}${id}`}>
                              <Table.Cell className="is-size-7 is-vcentered is-centered" size={150}>
                                {candidacy.positionName}
                              </Table.Cell>
                              <Table.Cell className="is-size-7 is-vcentered is-centered" size={200}>
                                {candidacy.name}
                              </Table.Cell>
                              <Table.Cell className="is-size-7 is-vcentered is-centered" size={150}>
                                {candidacy.cpf}
                              </Table.Cell>
                              <Table.Cell className="is-size-7 is-vcentered is-centered" size={200}>
                                {candidacy.status}
                              </Table.Cell>
                              <Table.Cell className="is-size-7 is-vcentered is-centered" size={100}>
                                <Input.Root className=" ">
                                  <Select.Content
                                    className="is-small is-rounded"
                                    color="is-grey"
                                    value={candidacy?.rating}
                                    setValue={(value) => {
                                      setFormContext((prev) => {
                                        const newList = UpdateValueInArrayOfObject(
                                          prev.list_reviews,
                                          'id',
                                          id,
                                          'rating',
                                          value,
                                        )
                                        return {
                                          ...prev,
                                          list_reviews: [...newList],
                                        }
                                      })
                                    }}
                                  >
                                    <Select.Option value="0" title="0" />
                                    <Select.Option value="1" title="1" />
                                    <Select.Option value="2" title="2" />
                                    <Select.Option value="3" title="3" />
                                    <Select.Option value="4" title="4" />
                                    <Select.Option value="5" title="5" />
                                  </Select.Content>
                                </Input.Root>
                              </Table.Cell>

                              <Table.Cell className="is-size-7 is-vcentered is-centered">
                                <Input.Root>
                                  <Input.Prompt
                                    className="is-small is-rounded"
                                    color="is-grey"
                                    value={candidacy?.comment}
                                    setValue={(value) => {
                                      setFormContext((prev) => {
                                        const newList = UpdateValueInArrayOfObject(
                                          prev.list_reviews,
                                          'id',
                                          id,
                                          'comment',
                                          value,
                                        )
                                        return {
                                          ...prev,
                                          list_reviews: [...newList],
                                        }
                                      })
                                    }}
                                  ></Input.Prompt>
                                </Input.Root>
                              </Table.Cell>
                            </Table.Row>
                          )
                        })}
                      </Table.Body>
                    </Table.Root>
                  </Column.Content>
                </Column.Root>
              </>
            )}
          </>
        </div>
      )}
    </>
  ) : (
    <>
      {/* lista de ajustes */}
      <>
        <div style={{ height: 1 }} className="is-fullwidth has-background-grey-lighter my-5"></div>
        <Column.Root>
          <Column.Content>
            <Column.Root>
              <Column.Content style={{ display: 'flex', gap: '1rem' }}>
                <p className="subtitle is-size-5 has-text-grey">
                  <Icon size={20} className={'mr-3'}>
                    bill
                  </Icon>
                  Lista de Aportes/Descontos
                </p>
                <Button.Content>
                  <Button.A className={'mr-4'} link={PathDoc.EventFinally} openNew color="is-light" loading={loading}>
                    Tutorial
                  </Button.A>
                </Button.Content>
              </Column.Content>
            </Column.Root>

            {formContext?.list_debts && (
              <Table.Root className="is-fullwidth is-hoverable is-narrow has-text-centered">
                <Table.Head>
                  <Table.Row key={'tableEventsHead'}>
                    <Table.Cell>Data</Table.Cell>
                    <Table.Cell>Vaga</Table.Cell>
                    <Table.Cell>Colaborador</Table.Cell>
                    <Table.Cell>CPF</Table.Cell>
                    <Table.Cell>Aporte/Desconto</Table.Cell>
                    <Table.Cell>Valor</Table.Cell>
                    <Table.Cell>Motivo</Table.Cell>
                  </Table.Row>
                </Table.Head>
                <Table.Body>
                  {(formContext?.list_debts || []).map((candidacy) => {
                    const indexDebt = candidacy.index
                    return (
                      <Table.Row key={`row_${indexDebt}`}>
                        <Table.Cell>{candidacy.date}</Table.Cell>
                        <Table.Cell>{candidacy.positionName}</Table.Cell>
                        <Table.Cell>{candidacy.name}</Table.Cell>
                        <Table.Cell>{candidacy.cpf}</Table.Cell>
                        <Table.Cell size={10}>
                          <Select.Root>
                            <Select.Content
                              disabled={true}
                              required={true}
                              color="is-grey"
                              value={candidacy?.typeDebt}
                              setValue={(value) => {
                                setFormContext((prev) => {
                                  const newList = UpdateValueInArrayOfObject(
                                    prev.list_debts,
                                    'index',
                                    indexDebt,
                                    'typeDebt',
                                    value,
                                  )
                                  return {
                                    ...prev,
                                    list_debts: [...newList],
                                  }
                                })
                              }}
                            >
                              <Select.Option value="D" title="Desconto" />
                              <Select.Option value="C" title="Crédito" />
                            </Select.Content>
                          </Select.Root>
                        </Table.Cell>
                        <Table.Cell size={150}>
                          <Input.Root>
                            <Input.Contents alignIcon={'left'}>
                              <Input.Icon align="is-left">R$</Input.Icon>
                              <Input.ReadOnly>{candidacy?.valueDebt}</Input.ReadOnly>
                            </Input.Contents>
                          </Input.Root>
                        </Table.Cell>
                        <Table.Cell>
                          <Input.Root>
                            <Input.ReadOnly>{candidacy?.motivoDebt}</Input.ReadOnly>
                          </Input.Root>
                        </Table.Cell>
                      </Table.Row>
                    )
                  })}
                </Table.Body>
              </Table.Root>
            )}
          </Column.Content>
        </Column.Root>
      </>
      {/* lista de Favoritos */}
      <>
        <div style={{ height: 1 }} className="is-fullwidth has-background-grey-lighter my-5"></div>
        <Column.Root>
          <Column.Content>
            <Column.Root>
              <Column.Content style={{ display: 'flex', gap: '1rem' }}>
                <p className="subtitle is-size-5 has-text-grey">
                  <Icon size={20} className={'mr-3'}>
                    favorite
                  </Icon>
                  Lista de Favoritos
                </p>
                <Button.Content>
                  <Button.A className={'mr-4'} link={PathDoc.EventFinally} openNew color="is-light" loading={loading}>
                    Tutorial
                  </Button.A>
                </Button.Content>
              </Column.Content>
            </Column.Root>

            {formContext?.list_favorite?.length > 0 && (
              <Table.Root className="is-fullwidth is-hoverable is-narrow has-text-centered">
                <Table.Head>
                  <Table.Row key={'tableEventsHead'}>
                    <Table.Cell>Vaga</Table.Cell>
                    <Table.Cell>Colaborador</Table.Cell>
                    <Table.Cell>CPF</Table.Cell>
                  </Table.Row>
                </Table.Head>
                <Table.Body>
                  {(formContext?.list_favorite || []).map((candidacy) => {
                    const index = candidacy.index
                    return (
                      <Table.Row key={`row_favorite_${candidacy.id}${index}`}>
                        <Table.Cell>{candidacy.positionName}</Table.Cell>
                        <Table.Cell>{candidacy.name}</Table.Cell>
                        <Table.Cell>{candidacy.cpf}</Table.Cell>
                      </Table.Row>
                    )
                  })}
                </Table.Body>
              </Table.Root>
            )}
          </Column.Content>
        </Column.Root>
      </>
      <>
        <Column.Root className="mx-5 my-2">
          <Checkbox.Root text="Adicionar essa Staff aos Favoritos">
            <Checkbox.Content
              key={`checkfavoriteAll`}
              value={formContext}
              setValue={setFormContext}
              field={'favoriteAll'}
              disabled={true}
            />
          </Checkbox.Root>
        </Column.Root>
        <Column.Root className="mx-5 my-2">
          {/* <Checkbox.Root text="Criar nova equipe">
            <Checkbox.Content
              key={`checkcreateNewTeams`}
              value={formContext}
              setValue={setFormContext}
              field={'createNewTeams'}
              disabled={true}
            />
          </Checkbox.Root> */}
        </Column.Root>
        <Column.Content>
          {/* <Input.Root>
            <Input.Label required={true} className="has-text-grey">
              Motivo padrão
            </Input.Label>
            <Input.ReadOnly>{formContext?.motivoDefaultBlocked}</Input.ReadOnly>
          </Input.Root> */}
        </Column.Content>
      </>
      {/* lista de Bloqueados */}
      <>
        <div style={{ height: 1 }} className="is-fullwidth has-background-grey-lighter my-5"></div>
        <Column.Root>
          <Column.Content>
            <Column.Root>
              <Column.Content style={{ display: 'flex', gap: '1rem' }}>
                <p className="subtitle is-size-5 has-text-grey">
                  <Icon size={20} className={'mr-3'}>
                    block
                  </Icon>
                  Lista de Bloqueados
                </p>
                <Button.Content>
                  <Button.A className={'mr-4'} link={PathDoc.EventFinally} openNew color="is-light" loading={loading}>
                    Tutorial
                  </Button.A>
                </Button.Content>
              </Column.Content>
            </Column.Root>

            {(formContext?.list_blocked || []).length > 0 && (
              <Table.Root className="is-fullwidth is-hoverable is-narrow has-text-centered">
                <Table.Head>
                  <Table.Row key={'tableEventsHead'}>
                    <Table.Cell>Vaga</Table.Cell>
                    <Table.Cell>Colaborador</Table.Cell>
                    <Table.Cell>CPF</Table.Cell>
                    <Table.Cell>Motivo</Table.Cell>
                  </Table.Row>
                </Table.Head>
                <Table.Body>
                  {(formContext?.list_blocked || []).map((candidacy) => {
                    const index = candidacy.index
                    return (
                      <Table.Row key={`row_blocked_${candidacy.id}${index}`}>
                        <Table.Cell>{candidacy.positionName}</Table.Cell>
                        <Table.Cell>{candidacy.name}</Table.Cell>
                        <Table.Cell>{candidacy.cpf}</Table.Cell>
                        <Table.Cell>
                          <Input.Root>
                            <Input.ReadOnly>{candidacy?.motivoBlocked}</Input.ReadOnly>
                          </Input.Root>
                        </Table.Cell>
                      </Table.Row>
                    )
                  })}
                </Table.Body>
              </Table.Root>
            )}
          </Column.Content>
        </Column.Root>
      </>

      {/* lista de Avaliações */}
      <>
        <div style={{ height: 1 }} className="is-fullwidth has-background-grey-lighter my-5"></div>
        <Column.Root>
          <Column.Content>
            <Column.Root>
              <Column.Content>
                <p className="subtitle is-size-5 has-text-grey">
                  <Icon size={20} className={'mr-3'}>
                    start
                  </Icon>
                  Avaliar Colaboradores
                </p>
              </Column.Content>
            </Column.Root>

            {(formContext?.list_reviews || []).length > 0 && (
              <Table.Root className="is-fullwidth is-hoverable is-narrow has-text-centered">
                <Table.Head>
                  <Table.Row key={'tableEventsHead'}>
                    <Table.Cell>Vaga</Table.Cell>
                    <Table.Cell>Colaborador</Table.Cell>
                    <Table.Cell>CPF</Table.Cell>
                    <Table.Cell>Nota</Table.Cell>
                    <Table.Cell>Comentário</Table.Cell>
                  </Table.Row>
                </Table.Head>
                <Table.Body>
                  {(listFiltered || []).map((candidacy) => {
                    const index = candidacy.index
                    return (
                      <Table.Row key={`row_blocked_${candidacy.id}${index}`}>
                        <Table.Cell>{candidacy.positionName}</Table.Cell>
                        <Table.Cell>{candidacy.name}</Table.Cell>
                        <Table.Cell>{candidacy.cpf}</Table.Cell>
                        <Table.Cell>{candidacy.rating}</Table.Cell>
                        <Table.Cell>{candidacy.comment}</Table.Cell>
                      </Table.Row>
                    )
                  })}
                </Table.Body>
              </Table.Root>
            )}
          </Column.Content>
        </Column.Root>
      </>
    </>
  )
}
